import React, { Fragment, useEffect, useState } from "react";
import { Col, Container, Form, Row, Table } from "react-bootstrap";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import Navbar from "../../Components/Navbar/Navbar";
import Modal from "antd/es/modal/Modal";
import "./Inventory.css";
import cleanLogo from "../../Assets/Images/Login/transparent_bg.png";
import {
    dateFormat,
    getTodayDateISO,
    getType,
    numberFormat,
    toastStyle,
    refreshPage
} from "../../Helpers/Utils/Common";
import {
    getTransferReceive, updateTransferReceiveStatus,
} from "../../Helpers/apiCalls/Inventory/TransferApi";
import TransferModal from "./Transfer/TransferModal";
import toast from "react-hot-toast";
import noDataImg from "../../Assets/Images/no-data-img.png";
import moment from "moment";
import Footer from "../../Components/Footer/Footer";

export default function ViewTransferReceive() {
    const { id, type } = useParams();
    let navigate = useNavigate();
    const [inactive, setInactive] = useState(true);
    const userType = getType();

    // DATA HANDLERS
    const [receiveItems, setReceiveItems] = useState([])
    const [status, setStatus] = useState("")
    const [preview, setPreview] = useState(false);
    const [fileList, setFileList] = useState([]);
    const [previewFile, setPreviewFile] = useState("");
    const [newTransfer, setNewTransfer] = useState({
        transfer_date: "",
        transfer_receive_date: "",
        transfer_number: "",
        branch_from: "",
        branch_to: "",
        remarks: "",
        dispatcher: "0",
        received_by: "",
    });
    /* print modal handler */
    const [showPrintModal, setShowPrintModal] = useState(false);
    const handleShowPrintModal = () => setShowPrintModal(true);
    const handleClosePrintModal = () => setShowPrintModal(false);

    /* Approve Modal */
    const [showApproveModal, setShowApproveModal] = useState(false);
    const handleShowApproveModal = () => setShowApproveModal(true);
    const handleCloseApproveModal = () => setShowApproveModal(false);


    //DISABLE SCROLL FUNCTION
    function limitScroll() {
        var numericInputs = document.querySelectorAll('.numeric-input');
        numericInputs.forEach(function(input) {
          input.addEventListener('wheel', function(e) {
            e.preventDefault();
          });
        });
      }
    limitScroll();

    function renderTable() {
        return (
            <Table className="ps-table">
                <thead>
                    <tr>
                        <th>Item</th>
                        <th>Unit</th>
                        <th>Expected</th>
                        <th>Received</th>
                    </tr>
                </thead>
                <tbody>
                    {receiveItems.map((item, index) => {
                        // 
                        return (
                            <tr key={index}>
                                <td className="franchise-td-gray">
                                    {item.label}
                                </td>
                                <td className="franchise-td-gray">
                                    {item.unit}
                                </td>
                                <td className="franchise-td-gray">
                                    {item.expected_qty}
                                </td>
                                <td className="franchise-td-gray">
                                    {numberFormat(item.quantities)}
                                </td>
                            </tr>
                        );
                    })}
                </tbody>
            </Table>
        );
    }

    async function handleChangeStatus() {
        const response = await updateTransferReceiveStatus(id, status);
        if (response.data) {
            toast.success(response.data.message, {
                style: toastStyle(),
            });
            setTimeout(() => {
                navigate("/transfer-receive")
            }, 1000);
        } else {
            response.error?.response?.data?.messages.map((data) => {
                return toast.error(data);
            })
            setTimeout(() => {
                navigate("/transfer-receive")
            }, 1000);
        }
    }

    async function handlePrintPI() {
        toast.loading("Printing Transfer Details", { style: toastStyle() });
        handleClosePrintModal();
        setTimeout(() => {
        toast.dismiss();
        Print();
        }, 1000);
    }

    function Print() {
        let printContents = document.getElementById("printablediv").innerHTML;
        let originalContents = document.body.innerHTML;
        document.body.innerHTML = printContents;
        window.print(printContents);
        document.body.innerHTML = originalContents;
        refreshPage();
    }


    async function fetchTransfer() {
        setFileList([])

        const response = await getTransferReceive(id);

        if (response.data) {
          var data = response.data.data[0];
          setNewTransfer({
            id: data.id,
            transfer_receive_id: data.id,
            transfer_id: data.transfer_id,
            transfer_date: data.transfer_date,
            transfer_number: data.transfer_number,
            branch_to: data.branch_to,
            branch_to_name: data.branch_to_name,
            branch_from: data.branch_from,
            branch_from_name: data.branch_from_name,
            remarks: data.remarks,
            status: data.status,
            dispatcher: data.dispatcher,
            dispatcher_name: data.dispatcher_name,
            completed_by_name: data.completed_by_name,
            received_by_name: data.received_by_name,
            received_by_name_signature: data.received_by_name_signature,
            transfer_receive_date: data.transfer_receive_date
              ? dateFormat(data.transfer_receive_date)
              : "",
            received_by: data.completed_by,
          });
          
          var itemEntries = data.transfer_receive_items;
          var clean = itemEntries.map((entry) => {
            var info = {};
            info.name = "item_id";
            info.id = entry.id;
            info.value = entry.item_id;
            info.label = entry.item_name;
            info.entry = {
              name: "item_id",
              value: entry.item_id,
              label: entry.item_name,
            };
            info.unit = entry.unit;
            info.prices = entry.price;
            info.expected_qty = entry.transfer_qty
                ? numberFormat(entry.transfer_qty)
                : "Additional";
            info.quantities = entry.qty;
            return info;
          });
            setReceiveItems(clean);
            setFileList(response.data.data[0].transfer_receive_attachments);

        }
    }

    useEffect(() => {
        fetchTransfer();
    }, []);


    return (
        <div>
            <div className="page">
                <Navbar
                    onCollapse={(inactive) => {
                        setInactive(inactive);
                    }}
                    active={"TRANSFERS"}
                />
            </div>
            <div
                className={`manager-container ${
                    inactive ? "inactive" : "active"
                }`}
            >
                <Row className="mb-4">
                    <Col xs={12} lg={7}>
                    {type === "create" ? (
                        <h1 className="page-title ps-2 ms-3 ms-md-0 ps-md-0 ms-md-0 fs-2">
                            RECEIVE TRANSFER{" "}
                        </h1>
                    ) : (
                        <h1 className="page-title ps-2 ms-3 ms-md-0 ps-md-0 ms-md-0 fs-2">
                            REVIEW TRANSFER{" "}
                        </h1>
                    )}
                    </Col>
                </Row>

                {/* FORM */}

                <div className="edit-form ps-form">
                    <Fragment>
                        <Row className="mb-3">
                            <Col xs={12} lg={3}>
                            <span className="nc-modal-custom-row uppercase">
                                    Transfer Receive Date
                                    <label className="badge-required">{` *`}</label>
                                </span>
                                <Form.Control
                                    type="text"
                                    name="transfer_receive_date"
                                    defaultValue={newTransfer.transfer_receive_date}
                                    className="react-select-container"
                                    disabled
                                />
                            </Col>
                            <Col xs={12} lg={3} className="mt-4 mt-lg-0">
                            <span className="nc-modal-custom-row uppercase">
                                    transfer slip no.
                                    <label className="badge-required">{` *`}</label>
                                </span>
                                <Form.Control
                                    type="number"
                                    name="transfer_number"
                                    defaultValue={newTransfer.transfer_number}
                                    className="react-select-container"
                                    disabled
                                />
                            </Col>
                            <Col xs={12} lg={3} className="mt-4 mt-lg-0">
                            <span className="nc-modal-custom-row uppercase">
                                    From
                                    <label className="badge-required">{` *`}</label>
                                </span>
                                <Form.Control
                                    type="text"
                                    name="branch_from_name"
                                    defaultValue={newTransfer.branch_from_name}
                                    className="react-select-container"
                                    disabled
                                />
                             
                            </Col>
                            <Col xs={12} lg={3} className="mt-4 mt-lg-0">
                            <span className="nc-modal-custom-row uppercase">
                                    To
                                    <label className="badge-required">{` *`}</label>
                                </span>
                                <Form.Control
                                    type="text"
                                    name="branch_to_name"
                                    defaultValue={newTransfer.branch_to_name}
                                    className="react-select-container"
                                    disabled
                                />
                                
                            </Col>
                        </Row>
                        <Row>
                            <Col xs={12} lg={6}>
                            <span className="nc-modal-custom-row uppercase">
                                    Dispatcher
                                </span>
                                <Form.Control
                                    type="text"
                                    name="dispatcher_name"
                                    defaultValue={newTransfer.dispatcher_name}
                                    className="react-select-container"
                                    disabled
                                />
                            </Col>
                            <Col xs={12} lg={6} className="mt-4 mt-lg-0">
                            <span className="nc-modal-custom-row uppercase">
                                    Received By
                                    <label className="badge-required">{` *`}</label>
                                </span>
                                <Form.Control
                                    type="text"
                                    name="received_by_name"
                                    defaultValue={newTransfer.received_by_name}
                                    className="react-select-container"
                                    disabled
                                />
                            </Col>
                        </Row>
                    </Fragment>

                    {/* INVOICES */}
                    <div className="mt-4 pt-3 d-flex flex-column">
                        <span className="nc-modal-custom-row mb-2 uppercase">
                            ITEM LIST{" "}
                            <label className="badge-required">{` *`}</label>
                        </span>
                        <Container fluid className="edit-purchased-items">
                            {receiveItems.length === 0 ? (
                                <div className="entries-not-found">
                                    {"Items not found."}
                                </div>
                            ) : (
                                <>
                                    {<>{renderTable()}</>}
                                </>
                            )}
                        </Container>
                    </div>
                    <div className="mt-4 noPrint mx-3">
                        <Row className="review-data mb-2">
                            FILE ATTACHMENTS
                        </Row>
                        <Row className="">
                            {
                                fileList && fileList.map((attachment) => (
                                    <Col xs={1} onClick={() => {setPreviewFile(attachment.file_url); setPreview(true)}} className="cursor-pointer preview-container">
                                        <img src={attachment.file_url}  className="img-preview"/>
                                    </Col>
                                ))
                            }
                            {
                                !fileList || fileList.length === 0 && 
                                <Col xs={1}>
                                <div className="no-data-cont d-flex justify-content-left preview-container">
                                    <img src={noDataImg} alt="no data found" className="img-preview"/>
                                </div>
                                </Col>
                            }
                        </Row>
                    </div>
                </div>

                <div className="d-flex justify-content-end pt-5">
                    <button
                        type="button"
                        className="button-secondary me-3"
                        onClick={() => navigate("/transfer-receive")}
                        >
                        Close
                    </button>
                    <button
                        type="button"
                        className="button-primary me-3"
                        onClick={handleShowPrintModal}
                    >
                        Print
                    </button>
                    {newTransfer.status === "for_approval" && (
                        <button
                            type="button"
                            className="button-tertiary me-3"
                            onClick={() => navigate("/transfer-receive/update/" +id)}
                            >
                            Edit
                        </button>
                    )}
                    {newTransfer.status === "for_approval" && (
                    <>
                        {(userType === "admin" || userType === "warehouse_manager" || userType === "branch_oic") && (
                        <>
                            <button
                                type="button"
                                className="button-warning me-3"
                                onClick={() => {
                                    setStatus("rejected")
                                    handleShowApproveModal()
                                }}
                            >
                                Disapprove
                            </button>
                            <button
                                type="button"
                                className="button-primary"
                                onClick={() => {
                                    setStatus("approved")
                                    handleShowApproveModal()
                                }}
                            >
                                Approve
                            </button>
                        </>
                        )}
                    </>
                    )}
                </div>
                <br />
            </div>

            {/* PRINT VIEW */}
            <div
                className="print-container px-3 py-2 display-none"
                id="printablediv"
            >
                <div className="text-end print-header d-flex flex-column">
                    <span>TRANSFER RECEIVE NO. {id}</span>
                    <span className="text-uppercase">
                        {moment(getTodayDateISO()).format("MMMM DD, yyyy")}
                    </span>
                </div>
                <div className="d-flex justify-content-center">
                    <img src={cleanLogo} className="print-logo" alt="" />
                </div>
                <div className="print-top">
                    <h5 className="print-shop-header d-flex justify-content-center">LEYTE PAPERWORLD</h5>
                    <h5 className="print-shop-header d-flex justify-content-center">168 M.H. Del Pilar, Tacloban City, Leyte</h5>
                    <h5 className="print-shop-header d-flex justify-content-center">(053) 325-3888 (053) 325-7088</h5>
                    <h5 className="print-shop-header d-flex justify-content-center">penpaperworld@yahoo.com</h5>
                    <h5 className="print-shop-header d-flex justify-content-center">TRANSFER RECEIVE</h5>
                </div>
                <div className="print-body mt-2">
                    <Container fluid>
                        <Row className="review-container py-2">
                            <Col>
                                <div className="d-flex align-items-center">
                                    <Col xs={4} className="print-label">
                                        Transfer Slip No.:
                                    </Col>
                                    <Col xs={7} className="print-data">
                                        {newTransfer.transfer_number}
                                    </Col>
                                </div>
                                <div className="d-flex align-items-center">
                                    <Col xs={4} className="print-label">
                                        Transfer Receive Date:
                                    </Col>
                                    <Col xs={7} className="print-data">
                                        {dateFormat(newTransfer.transfer_date)}
                                    </Col>
                                </div>
                                <div className="d-flex align-items-center">
                                    <Col xs={4} className="print-label">
                                        Branch From:
                                    </Col>
                                    <Col xs={7} className="print-data">
                                        {newTransfer.branch_from_name}
                                    </Col>
                                </div>
                                <div className="d-flex align-items-center">
                                    <Col xs={4} className="print-label">
                                        Branch To:
                                    </Col>
                                    <Col xs={7} className="print-data">
                                        {newTransfer.branch_to_name}
                                    </Col>
                                </div>
                            </Col>
                            <Col>
                                <div className="d-flex align-items-center">
                                    <Col xs={4} className="print-label">
                                        Dispatcher:
                                    </Col>
                                    <Col xs={7} className="print-data">
                                        {newTransfer.dispatcher_name}
                                    </Col>
                                </div>
                                <div className="d-flex align-items-center">
                                    <Col xs={4} className="print-label">
                                        Received By:
                                    </Col>
                                    <Col xs={7} className="print-data">
                                        {newTransfer.received_by_name}
                                    </Col>
                                </div>
                            </Col>
                        </Row>
                    </Container>

                    <div className="mt-4 d-flex flex-column">
                        <span className="review-data mb-2 nc-modal-custom-row">
                            ITEM LIST
                        </span>
                        <div className="d-flex mt-2 justify-content-evenly">
                            <div className="print-table mt-3 mx-2">
                                {renderTable()}
                            </div>
                        </div>
                    </div>
                    <Row className="mt-5">
                    <Col xs={6} className="print-sig justify-content-center d-flex">
                        <img src={newTransfer.received_by_name_signature} className="print-logo" />
                    </Col>
                    <Col xs={6} className="print-sig justify-content-center d-flex">
                        <img src={newTransfer.approved_by_name_signature} className="print-logo" alt=""/>
                    </Col>
                    </Row>
                    <Row className="mt-2 mb-5">
                    <Col xs={6} className="print-sig justify-content-center d-flex">
                        <Row className="print-sig justify-content-center gotham">
                            {newTransfer.received_by_name}
                        <div className="margin-underline"></div>
                        Received by
                        </Row>
                    </Col>
                    <Col xs={6} className="print-sig justify-content-center d-flex">
                        <Row className="print-sig justify-content-center gotham">
                        {newTransfer.approved_by_name}
                        <div className="margin-underline"></div>
                        Approved by
                        </Row>
                    </Col>
                    </Row>
                </div>
            </div>

            <TransferModal
                show={showApproveModal}
                hide={handleCloseApproveModal}
                type="Approve transfer request"
                handler={handleChangeStatus}
            />
            <TransferModal
                show={showPrintModal}
                hide={handleClosePrintModal}
                type="print"
                page="transaction"
                handler={handlePrintPI}
            />`
            <Modal
                open={preview}
                title={""}
                footer={null}
                onCancel={() => setPreview(false)}
            >
                <img
                alt="attachment"
                style={{
                    width: "100%",
                }}
                src={previewFile}
                />
            </Modal>
            <Footer/>
        </div>
    );
}

ViewTransferReceive.defaultProps = {
    add: false,
    edit: false,
};
